/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'
import { DATA_GRID_TOKENS } from 'src/components/ts-components/DataGrid/tokens'
import {
  GRID_ICON_PATHS,
  type GridIconName,
} from '../../../constants/gridIcons'

interface GridIconProps {
  name: GridIconName
}

/**
 * One AG Grid Quartz icon at the theme's icon size, stroked in the current
 * text color, so its parent sets the color. Decorative: the control around it
 * carries the accessible name.
 */
const GridIcon: React.FC<GridIconProps> = ({ name }) => {
  'use memo'

  return (
    <svg
      css={iconStyles}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
      focusable='false'
    >
      {GRID_ICON_PATHS[name].map((d) => (
        <path key={d} d={d} vectorEffect='non-scaling-stroke' />
      ))}
    </svg>
  )
}

export default GridIcon

const iconStyles = css`
  flex: 0 0 auto;
  width: ${DATA_GRID_TOKENS.iconSize}px;
  height: ${DATA_GRID_TOKENS.iconSize}px;
`
